import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

import { IEmbeddedContentLink, MAX_EMBEDDED_LINKS } from 'rev-portal/scheduledEvents/common/EmbeddedContentTypes';

import { EditWebcastBaseSettingsComponent } from './EditWebcastBaseSettings.Component';

@Component({
	selector: 'edit-webcast-embedded-content',
	templateUrl: './EditWebcastEmbeddedContent.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EditWebcastEmbeddedContentComponent),
		multi: true
	}, {
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => EditWebcastEmbeddedContentComponent),
		multi: true,
	}],
	standalone: false
})
export class EditWebcastEmbeddedContentComponent extends EditWebcastBaseSettingsComponent implements ControlValueAccessor {
	@Input() public webcastId = '';
	@Input() public isSidebar = false;

	public readonly MAX_EMBEDDED_LINKS = MAX_EMBEDDED_LINKS;
	public readonly isDuplicateNameForForm = linkName => this.contentLinks.some((c, index) => c.name === linkName && index !== this.editingLinkIndex);

	public onTouched: () => void = () => undefined;
	public onChange: (contentLinks: IEmbeddedContentLink[]) => void = () => undefined;

	public contentLinks: IEmbeddedContentLink[] = [];
	public newLink: IEmbeddedContentLink | null = null;
	public isAddingNewLink = false;
	public editingLinkIndex: number | null = null;

	public isAddNewDisabled(): boolean {
		return this.isAddingNewLink || this.contentLinks?.length >= this.MAX_EMBEDDED_LINKS;
	}

	public onAddNewClick(): void {
		this.newLink = {
			name: '',
			code: '',
			icon: ''
		};
		this.editingLinkIndex = null;
		this.isAddingNewLink = true;
	}

	public onEditEntry(index: number): void {
		this.newLink = { ...this.contentLinks[index] };
		this.editingLinkIndex = index;
		this.isAddingNewLink = true;
	}

	public onCancelAddEntry(): void {
		this.newLink = null;
		this.editingLinkIndex = null;
		this.isAddingNewLink = false;
	}

	public onSaveEntry(link: IEmbeddedContentLink): void {
		if (this.editingLinkIndex !== null) {
			this.contentLinks[this.editingLinkIndex] = {
				...this.contentLinks[this.editingLinkIndex],
				...link
			};
		} else {
			this.contentLinks.push({ ...link });
		}

		this.onCancelAddEntry();
	}

	public onDeleteEntry(index: number): void {
		this.contentLinks.splice(index, 1);
	}

	public writeValue(links: IEmbeddedContentLink[]): void {
		this.contentLinks = links;
		if (!this.contentLinks) {
			this.contentLinks = [];
		}
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

}
